import React from 'react';
import ContentTitle from '../../PathBuilder/ContentList/ContentTitle';
import ContentStatus from '../Content/Status';

const Header = ({
  type,
  title,
  parent,
  status,
  progress,
  formattedStatus,
  required,
  dateAdded,
  dueDate,
  isOverdue,
  badge,
}) => (
  <div className="PathContent-header ai-fs">
    <ContentTitle {...{ parent, title, type, badge }} />
    <ContentStatus
      {...{
        status,
        formattedStatus,
        progress,
        required,
        dateAdded,
        dueDate,
        isOverdue,
      }}
    />
  </div>
);

export default Header;
